import { ReactNode } from 'react';
import { Button } from '@/theme/components';
import { Modal, Stack, styled } from '@/theme/index';

/**
 * This is a generic component which allows a user to edit some feature of
 * their account, and provides the boilerplate common to all the different
 * edit account modals. It renders a Modal (see theme/Modal), modified to
 * not show an X icon, along with a few other props detailed below.
 */
export function EditAccountInfoModal({
  children,
  isOpen,
  onCloseHandle,
  onSubmit,
  buttonText,
  headerText,
  dataCy = 'edit_account',
}: EditAccountInfoModalProps) {
  return (
    <ModalWithoutExplicitClose
      open={isOpen}
      onClose={onCloseHandle}
      title={headerText}
      data-cy={`${dataCy}_modal}`}
    >
      <Stack direction="column" alignItems="center">
        {children}
        <Button
          fullWidth
          variant="contained"
          color="success"
          onClick={onSubmit}
          data-cy={`${dataCy}_update_btn`}
        >
          {buttonText}
        </Button>
        <Button
          color="success"
          onClick={onCloseHandle}
          data-cy={`${dataCy}_update_btn`}
          sx={{ mt: 2 }}
        >
          Cancel
        </Button>
      </Stack>
    </ModalWithoutExplicitClose>
  );
}
interface EditAccountInfoModalProps {
  /** The child elements which are responsible for editing a specific account feature, for example payment info */
  children?: ReactNode | ReactNode[];
  /** If true, the modal is open */
  isOpen: boolean;
  /** Callback fired when the component requests to be closed */
  onCloseHandle: () => void;
  /** Callback fired when the user submits the form */
  onSubmit: () => void;
  /** The text displayed on the submit button */
  buttonText: string;
  /** The title text for the modal (see Modal theme component) */
  headerText: string;
  dataCy?: string;
}

const ModalWithoutExplicitClose = styled(Modal)`
  .MuiIconButton-root {
    display: none;
  }
`;
